import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import CustomInvoiceBuilder from '../../components/vendor/invoice/CustomInvoiceBuilder';

const VendorInvoiceCreate = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-3 sm:p-6">
     <div className="space-y-3 sm:space-y-4">
      <div>
        <Link
          to="/vendor/invoices"
          className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-4"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to invoices
        </Link>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Custom invoice</h1>
        <p className="text-sm text-gray-600 mt-1 max-w-2xl">
          Create invoices for platform clients, guest contacts, or one-off work — with any line items.
          Optionally link an existing booking, or leave it unlinked. Preview updates live; print or save as PDF.
        </p>
      </div>
      <CustomInvoiceBuilder />
    </div>
    </div>
  );
};

export default VendorInvoiceCreate;
